import { render, staticRenderFns } from "./rateLimitsIndicator.vue?vue&type=template&id=8354516c&"
import script from "./rateLimitsIndicator.vue?vue&type=script&lang=ts&"
export * from "./rateLimitsIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./rateLimitsIndicator.vue?vue&type=style&index=0&id=8354516c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports